import React, { useState } from "react";
import {
    Button, Modal, Input, Collapse, Radio, Popconfirm, Empty
} from "antd";
import {
    CloseOutlined, CaretRightOutlined, FolderOpenFilled, FolderFilled
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { loadSingleCategoryReports } from "../../utils/report/ReportsHelper";
import { setReportBuilderMode } from "../../store/components/ReportBuilder.slice";
import { setSelectedQuickReport } from "../../store/components/Reports.slice";
import { needToConfirmSavingQuickReports } from "../../utils/confirmation/ConfirmationHelper";
import useGetQuickReports from "../../hooks/QuickReports/useGetQuickReports";
import useSearchInQR from "../../hooks/QuickReports/useSearchInQR";
import { dynamicSort, folderStyle } from "../../utils/MainHelper";
import RenderComponent from "../General/RenderComponent"

const { Panel } = Collapse;
function QuickReportsModal({
    visible,
    onClose = () => { }
}) {
    const dispatch = useDispatch();
    const [searchedText, setsearchedText] = useState("");

    const { setup: { country } } = useSelector((state) => state.buildTargets);
    const { selectedQuickReport, quickReportTypeToAdd } = useSelector((state) => state.reports);
    const { mode } = useSelector((state) => state.reportBuilder);

    const {
        activeCollapse, tempSelected,
        setActiveCollapse, settempSelected, qrList
    } = useGetQuickReports(visible);
    const searchedData = useSearchInQR(qrList, searchedText);

    const data = (searchedData.length ? searchedData : qrList).sort(dynamicSort("name"))

    const canContinue = !(() => {
        if (!tempSelected) return false
        // if (mode !== "singlecategory") return false;
        if (tempSelected && selectedQuickReport) {
            return (`${selectedQuickReport.parent.name} - ${selectedQuickReport.name}` !== `${tempSelected.parent.name} - ${tempSelected.name}`);
        }
        return tempSelected;
    })();
    const { confirm, confirmText, withAppend } = needToConfirmSavingQuickReports(tempSelected);
    const updateQuickReports = () => {
        onClose(false);
        dispatch(setSelectedQuickReport(tempSelected));

        if (quickReportTypeToAdd === "new") {
            dispatch(setReportBuilderMode("singlecategory"));
        } else {
            loadSingleCategoryReports(undefined, "advanceAddFreeForm");
        }
    };
    const hasQR = data.length && country;
    return (
        <Modal
            open={visible}
            closable={false}
            maskClosable={false}
            title={(
                <div className="d-flex" style={{ width: "100%" }}>
                    <div className="d-flex-col flex-1">
                        <b className="report--quickreports--title">Report Library</b>
                        <p className="report--quickreports--subtitle">
                            Select report you would like to associate with your target audience.
                        </p>
                    </div>
                    <Button
                        style={{ padding: 0, marginLeft: "5mm" }}
                        type="text"
                        icon={<CloseOutlined />}
                        onClick={() => {
                            onClose(false);
                        }}
                    />
                </div>
            )}
            className="report--quickreports"
            style={{ width: "100%", height: "100%" }}
            footer={(
                <div className="d-flex justify-content-end gap-1">
                    <Button onClick={() => { onClose(false); }}>
                        Cancel
                    </Button>
                    {confirm ? (
                        <Popconfirm
                            placement="topRight"
                            title={confirmText}
                            onConfirm={updateQuickReports}
                            onCancel={() => {
                                if (withAppend) {
                                    onClose(false);
                                    dispatch(setSelectedQuickReport(tempSelected));
                                    loadSingleCategoryReports(false);
                                }
                            }}
                            okText={withAppend ? "Replace" : "Yes"}
                            cancelText={withAppend ? "Append" : "No"}
                        >
                            <Button type="primary" disabled={canContinue}>
                                Load Reports
                            </Button>
                        </Popconfirm>
                    ) : (
                        <Button type="primary" disabled={canContinue} onClick={updateQuickReports}>
                            Load Reports
                        </Button>
                    )}
                </div>
            )}
        >
            <div className="report--quickreports--content">
                <Input.Search
                    value={searchedText}
                    placeholder="Search"
                    style={{ width: "100%", marginBottom: "4mm" }}
                    onChange={(e) => {
                        setsearchedText(e.target.value);
                    }}
                    onSearch={(e) => {
                        setsearchedText(e);
                    }}
                />
                <div className={`report--quickreports--collapscontent${hasQR ? "" : " d-flex justify-content-center"}`}>
                    <RenderComponent
                        show={!hasQR}
                        isFullscreen
                        emptyProps={{
                            style: { width: "calc(100% - 10mm)" }
                        }}
                    >
                        <Collapse
                            activeKey={activeCollapse}
                            ghost
                            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                            expandIconPosition="end"
                            onChange={(e) => {
                                setActiveCollapse(e);
                            }}
                        >
                            {data.map((item) => {
                                return (
                                    <Panel
                                        className="report--quickreports--collapse--item"
                                        header={(
                                            <div className="d-flex align-items-center gap-5p">
                                                {activeCollapse.includes(parseInt(item.id, 10))
                                                    ? <FolderOpenFilled style={folderStyle} />
                                                    : <FolderFilled style={folderStyle} />}
                                                <span>{item.name}</span>
                                            </div>
                                        )}
                                        key={item.id}
                                    >
                                        <Radio.Group
                                            style={{ width: "100%", marginLeft: ".5mm" }}
                                            onChange={(e) => {
                                                settempSelected({
                                                    name: e.target.value,
                                                    parent: item
                                                });
                                            }}
                                            value={tempSelected?.name || ""}
                                        >
                                            {item.children.map((child) => (
                                                <Radio
                                                    className="report--quickreports--collapse--subitem"
                                                    key={child.name}
                                                    value={child.name}
                                                    style={{ width: "100%" }}
                                                >
                                                    {child.name}
                                                </Radio>
                                            ))}
                                        </Radio.Group>
                                    </Panel>
                                );
                            })}
                        </Collapse>
                    </RenderComponent>
                </div>
            </div>
        </Modal>
    );
}

export default QuickReportsModal;
